import Axios from 'axios'
import { ORDER_SET } from '../mutation-types'

const state = {
  items: [],
  productType: '',
  productName: '',
  activationStepsLink: ''
}

const actions = {
  fetch ({ commit }) {
    Axios.get('/order/info')
    .then((response) => {
      commit(ORDER_SET, response.data)
    })
    .catch((error) => {
      console.error(error)
    })
  }
}

const mutations = {
  [ORDER_SET] (state, newState) {
    state.items = newState.items
    state.productType = state.items[0].product_type
    state.productName = state.productType.name
    state.activationStepsLink = state.productType.activation_steps_link
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./vue/checkout/store/modules/order.js